import Vue from 'vue'

const LegalConfigModule = {
    namespaced: true,
    state: {
        legalConfig: null,
        configLoading: true,
    },
    actions: {
        SET_LEGAL_CONFIG({ state, commit }, legalConfig) {
            commit('SetLegalConfig', legalConfig);
        },
    },
    mutations: {
        SetLegalConfig: function (state, legalConfig) {
            state.legalConfig = legalConfig;
            state.configLoading = false;
        },
    },
    getters: {
        GetLegalConfig: function (state) {
            try {
                return state.legalConfig;
            } catch (err) {
                return null;
            }
        },
        LegalConfigLoaded: function (state) {

            return state.legalConfig != null
        },
        LegalConfigLoading: function (state) {
            return state.configLoading
        },
        GetAvailableStatuses : function (state, getters, rootState ,rootGetters) {
            return (previous, wfstatus, country) => {
                let transitions = [];

                if (!rootGetters.isInRole("ADMIN")){
                    transitions = state.legalConfig.CONFIG.TRANSITIONS
                    .filter(x => x.PREVIOUS == null || x.PREVIOUS == undefined || x.PREVIOUS.map(y => y.toString()).includes(previous))
                    .filter(x => x.WF == null || x.WF == undefined || x.WF.includes(wfstatus))
                    .filter(x => x.ROLES == null || x.ROLES == undefined || rootGetters.isInRoleArr(x.ROLES.map(role => role + '_' + country).join(',')))
                    .filter(x => x.NOT_IN_ROLES == null || x.NOT_IN_ROLES == undefined || !rootGetters.isInRoleArr(x.NOT_IN_ROLES.map(role => role + '_' + country).join(',')))
                }
                else{
                    transitions = state.legalConfig.CONFIG.TRANSITIONS
                }
                
                return transitions
                .map(x => x.STATUS)
                .reduce(function (a, b) { return a.concat(b); }, []).filter(function(value, index, self){
                    return self.indexOf(value) === index
                }
                ).map(x => x.toString())
                
                
            }
        },
        GetDocSettings: function (state) { 
            return state.legalConfig.CONFIG.DOC_SETTINGS
        }

    }
}
export default LegalConfigModule;